const CONTENT_MANAGEMENT_INITIAL_STATE = {
	data: [],
	isContentPublished: true,
};

export default CONTENT_MANAGEMENT_INITIAL_STATE;
